// NotificacionInventario.actions.ts
import { queryClient } from '@/shared/query-client/query-client';
import { useMutation, useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { UseFetchEnabledParams, UseMutationsParams, UseUpdateParams } from "@/shared/interfaces";
import { urlBackend } from "@/shared/constants";
import { erpApi } from "@/shared/axios";
import { getUrlParamsFetch } from "@/shared/utils";
import { toApiError } from "@/shared/utils/general";
import { NotificacionInventario, NotificacionInventarioForm, NotificacionInventarioPagingResp, NotificacionInventarioParams } from '@/erp/inventario/notificacion-inventario';

const { get, post, put } = erpApi();

// get

export const useFetchGetNotificacionInventario = ({
  enabled = true,
  params,
}: UseFetchEnabledParams<NotificacionInventarioParams> = {}) => {
  return useQuery({
    queryKey: ['notificacion-inventario', ...Object.values(params ?? {})],
    queryFn: () => getNotificacionInventario(params),
    enabled: enabled,
    refetchOnWindowFocus: false,
    staleTime: 0,
    gcTime: 0,
  });
};

export const getNotificacionInventario = async (
  params?: NotificacionInventarioParams
) => {
  const queryParams = getUrlParamsFetch(params ?? {});
  return get<NotificacionInventarioPagingResp>(`${urlBackend}api/v1/notificacion-inventario/?${queryParams}`, true);
};

// create

export const useFetchPostNotificacionInventario = ({
  returnUrl,
  navigate
}: UseMutationsParams = {}) => {

  return useMutation({
    mutationFn: (data: NotificacionInventarioForm) => {
      return postNotificacionInventario(data)
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: ['notificacion-inventario']
      });

      navigate && returnUrl && navigate(returnUrl);

      toast.success(data.message);

    },
    onError: ((error) => {
      const data = toApiError(error)
      toast.error(data.message)
    }),
    onSettled: () => {

    },
  });
};

export const postNotificacionInventario = async (data: NotificacionInventarioForm) => {
  return await post<NotificacionInventario>(`${urlBackend}api/v1/notificacion-inventario/`, data, true);
};

// filter by id

export const useFetchGetByIdNotificacionInventario = (id: string) => {
  return useQuery({
    queryKey: ['notificacion-inventario', id],
    queryFn: async () => {
      return getByIdNotificacionInventario(id);
    },
    refetchOnWindowFocus: false,
  });
};

export const getByIdNotificacionInventario = async (id: string) => {
  const res = await get<NotificacionInventario>(`${urlBackend}api/v1/notificacion-inventario/${id}`, true);
  return res;
};

// update

export const useFetchPutNotificacionInventario = ({
  navigate,
  returnUrl
}: UseMutationsParams = {}) => {

  return useMutation({
    mutationFn: (data: UseUpdateParams<NotificacionInventarioForm>) => {
      return putNotificacionInventario(data);
    },
    onSuccess: (res) => {
      queryClient.invalidateQueries({
        queryKey: ['notificacion-inventario']
      });
      
      navigate && returnUrl && navigate(returnUrl);

      toast.success(res.message);
    },
    onError: (error) => {
      const data = toApiError(error)
      toast.error(data.message)
    },
    onSettled: () => {

    },
  });
};

export const putNotificacionInventario = async ({
  id,
  data
}: UseUpdateParams<NotificacionInventarioForm>) => {
  return put<NotificacionInventario>(`${urlBackend}api/v1/notificacion-inventario/${id}/`, data, true);
};
